import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatError } from "@/lib/api";
import { Logo } from "@/components/Navbar";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); } catch {}
    setSent(true);
  };
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-6"><Logo className="justify-center" /></div>
        <div className="bg-white rounded-2xl border border-gray-100 p-8 shadow-sm">
          <h1 className="text-2xl font-bold font-display">Passwort vergessen</h1>
          {sent ? (
            <p className="mt-4 text-gray-600 text-sm">Falls ein Konto mit dieser E-Mail existiert, haben wir dir einen Link zum Zurücksetzen gesendet.</p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <input required type="email" placeholder="E-Mail" data-testid="forgot-email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-gray-200" />
              <button data-testid="forgot-submit" className="w-full bg-[#E0243A] hover:bg-[#C81E33] text-white font-semibold py-3 rounded-xl">Link senden</button>
            </form>
          )}
          <div className="mt-4 text-sm text-center"><Link to="/login" className="text-[#E0243A] font-semibold">Zurück zur Anmeldung</Link></div>
        </div>
      </div>
    </div>
  );
}
